import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'xpLengthCheck' })
export class XpLengthCheckPipe implements PipeTransform {
  // eslint-disable-next-line class-methods-use-this
  transform(value: string = '', len: number): string {
    return (value || '').length > len ? `${value.substr(0, len)}...` : value;
  }
}
